/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * 
 * @export
 * @interface ApiAlertStatusEvent
 */
export interface ApiAlertStatusEvent {
    /**
     * 
     * @type {number}
     * @memberof ApiAlertStatusEvent
     */
    id?: number;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiAlertStatusEvent
     */
    assigner?: ApiAssignmentUser;
    /**
     * 
     * @type {string}
     * @memberof ApiAlertStatusEvent
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAlertStatusEvent
     */
    statusId: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertStatusEvent
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertStatusEvent
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiAlertStatusEvent
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the ApiAlertStatusEvent interface.
 */
export function instanceOfApiAlertStatusEvent(value: object): value is ApiAlertStatusEvent {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function ApiAlertStatusEventFromJSON(json: any): ApiAlertStatusEvent {
    return ApiAlertStatusEventFromJSONTyped(json, false);
}

export function ApiAlertStatusEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAlertStatusEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assigner': json['assigner'] == null ? undefined : ApiAssignmentUserFromJSON(json['assigner']),
        'status': json['status'],
        'statusId': json['statusId'],
        'createdTime': (new Date(json['createdTime'])),
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function ApiAlertStatusEventToJSON(json: any): ApiAlertStatusEvent {
    return ApiAlertStatusEventToJSONTyped(json, false);
}

export function ApiAlertStatusEventToJSONTyped(value?: ApiAlertStatusEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assigner': ApiAssignmentUserToJSON(value['assigner']),
        'status': value['status'],
        'statusId': value['statusId'],
        'createdTime': value['createdTime'].toISOString(),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

